<template>
  <div id="admincouponsview">
    <div class="pa-2">
      <v-row justify="space-between">
        <v-col>
          <Coupons />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import Coupons from "@/components/admin-components/global/Coupons.vue";
export default {
  name: "AdminCouponsView",
  components: { Coupons },
  data: () => ({}),
};
</script>
